module.exports = __webpack_public_path__ + "img/title-left1.dff13c9.png";